/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAvailabilityContainerViewProps } from './availability-container';

export default (props: IAvailabilityContainerViewProps) => {
    const {rows, header, customClass} = props;

    return (
        <div className={`${customClass}` || 'avail-container'}>
            <div className='header'>
                <div className='line left'></div>
                <h2 style={{textAlign: "center"}}>{header}</h2>
                <div className='line right'></div>
            </div>
            <div className="container">
                {rows && rows.length && rows.map((row: React.ReactNode, index: number) => {
                    return (
                        <div key={index}>
                            {row}
                        </div>
                    );
                })}
            </div>
        </div>
        
    );
};
